/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Events_Filters_AllInputs */

const es_billing_events_filters_all = /** @type {(inputs: Billing_Events_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

const en_billing_events_filters_all = /** @type {(inputs: Billing_Events_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Billing_Events_Filters_AllInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_events_filters_all = /** @type {((inputs?: Billing_Events_Filters_AllInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Events_Filters_AllInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_events_filters_all(inputs)
	return en_billing_events_filters_all(inputs)
});
export { billing_events_filters_all as "billing.events.filters.all" }